module.exports = __webpack_public_path__ + "img/sv80on.ddc52437.svg";